export const environment = {
  production: false,
  name: 'sandbox',
  apiBaseUrl: 'https://sandbox-api.arcanelegions.com/api'
};
